// extracted by mini-css-extract-plugin
export default {"winArrow":"WinArrow_winArrow__-kxOb"};